import Carriculam from "../components/Carriculam/Carriculam";
import AdmissionInfo from "../components/Admission_Info/AdmissionInfo";

export default function Academics() {
  return (
    <div>
       <Carriculam />
        <AdmissionInfo/>
    </div>
  )
}